import {Button} from "@mui/material";

const ButtonText = ({onClick, text, width, disabled = false, blue, orange, sx: sxProp}) => {
    return <Button
        onClick={onClick}
        disabled={disabled}
        variant="text"
        sx={{
            color: (theme) => blue ? theme.palette.primary.dark : orange ? theme.palette.secondary.add  : theme.palette.text.main,
            padding: 0,
            boxShadow: "none",
            textTransform: 'none',
            flexShrink: 0,
            textAlign: "left",
            justifyContent: "flex-start",
            whiteSpace: "nowrap",
            width: width != null ? "auto" : undefined,
            minWidth: width,
            "&:hover": {
                backgroundColor: "transparent",
                textDecoration: "underline",
                boxShadow: "none",
            },
            ...sxProp,
        }}>
        {text}
    </Button>
}
export default ButtonText